<template>
    <div class = "change-address-status-view">
        <!-- not be editable (*NOTE: kit by office is always editable, as no "DELIVERED" status), kit delivered (kit to patient only, since kit by office has no "DELIVERED" status) -->
        <div v-if = "!is_editable && is_kit_delivered" class = 'change-address-saved-view'>

            <img src="@/assets/ChangeShippingAddress/success_icon.svg" />
            <div class = "bold-content">
                Your Kit Has Already Been Delivered
            </div>

            <!-- know whether blooddraw or non-blooddraw, and haven't paid the (legacy) concierge fee-->
            <div v-if = "need_blood_draw!=null && !is_concierge_paid" class = 'next-step-notice clickable'
            @click = "clickNextStep">
               <span class = 'bold'>Next Step</span>
            </div>

            <!-- know whether blooddraw or non-blooddraw, and already paid the (legacy) concierge fee-->
            <div v-else-if = "need_blood_draw!=null && is_concierge_paid" class = 'next-step-notice clickable'
            @click = "clickNextStep">
                <span class = 'bold'>Next Step: </span>Schedule your prepaid Concierge Blood-Draw service
            </div>

            <!-- don't know whether blooddraw or non-blooddraw -->
            <div v-else  class = 'next-step-notice'>
               <span class = 'bold'>What's Next: </span>We will send your kit as soon as possible
            </div>

            <!--  common smaller text below buttons -->
            <div class = "regular-content">
                If you haven't received your kit, please <span class = 'link' @click ='clickContactUs'>Contact Support</span>.
            </div>
        </div>

        <!-- Error occurs when get address, or not editable and not "DELIVERED" -->
        <!-- kit to patient/kit by office -->
        <div v-else-if = "!is_editable" class = 'change-address-failed-view'>
            <img src="@/assets/ChangeShippingAddress/failed_icon.svg" />
            <div class = "bold-content">
                Change Address Failed  
            </div>
            <div v-if = "need_blood_draw!=null" class = 'next-step-notice clickable' @click = "clickNextStep">
               <span class = 'bold'>Next Step</span>
            </div>
            <div class = "regular-content">
                If your package will be/has been delivered to a wrong address, please <span class = 'link' @click ='clickContactUs'>Contact Us</span>.
            </div>
        </div>
        
        <!-- is_editable always true, after save or confirm information -->
        <!-- kit to patient, kit not delivered -->
        <!--kit by office -->
        <div v-else-if = "edits_saved" class = 'change-address-saved-view'>
            <img src="@/assets/ChangeShippingAddress/success_icon.svg" />
            <div class = "bold-content">
               {{ is_kit_shipped ? 'Change Address Request Sent!' : 'Information Saved!'}}
            </div>

            <!-- know whether blooddraw or non-blooddraw, and haven't paid the (legacy) concierge fee-->
            <div v-if = "need_blood_draw!=null && !is_concierge_paid" class = 'next-step-notice clickable'
            @click = "clickNextStep">
               <span class = 'bold'>Next Step</span>
            </div>

            <!-- know whether blooddraw or non-blooddraw, and already paid the (legacy) concierge fee-->
            <div v-else-if = "need_blood_draw!=null && is_concierge_paid" class = 'next-step-notice clickable'
            @click = "clickNextStep">
                <span class = 'bold'>Next Step: </span>Schedule your prepaid Concierge Blood-Draw service
            </div>

            <!-- don't know whether blooddraw or non-blooddraw -->
            <div v-else  class = 'next-step-notice'>
               <span class = 'bold'>What's Next: </span>We will send your kit as soon as possible
            </div>

            <div v-if = "is_kit_shipped" class = "regular-content">
                We'll review your request shortly. If approved, your shipping address will be updated automatically. 
                <br/>
                If not, please <span class = 'link' @click ='clickContactUs'>Contact Support</span> for further assistance..
            </div>
            <div v-else class = "regular-content">
                If you need to edit your address <span class = 'link' @click ='clickContactUs'>Contact Us</span>.
            </div>
        </div>

        <!-- is_editable is always true (jump from Inputs views), edits_saved is always false (won't save edits before solving duplicated patients) -->
        <!-- show this if users don't want to manually merge patients by themselves-->
        <div v-else-if = "show_contact_support_to_solve_duplicated_patient" class = 'change-address-saved-view'>
            <img src="@/assets/CollectStatus/not_collected_icon.svg" />
            <div class = 'bold-content'>
                Please contact us by <span class = 'link'>866-364-0963</span> to fix the potential duplicate patient problem before moving on to next step.
            </div>
        </div>
      
    </div>
</template>

<script>
import { useShippingAddressStore } from '@/stores/ShippingAddressStore.ts';
import { mapActions, mapState } from 'pinia';

export default{
    computed:{
        ...mapState(()=>useShippingAddressStore(),[
            'is_editable',
            'edits_saved',
            'is_kit_delivered',
            'need_blood_draw',
            'previous_shipping_address_data',
            'show_contact_support_to_solve_duplicated_patient',
            'is_concierge_paid',
        ]),
        is_kit_shipped(){
            return this.previous_shipping_address_data?.reason != 'LABEL_NOT_CREATED';
        }
    },
    methods:{
        ...mapActions(()=>useShippingAddressStore(),[
            'goToNextStep',
        ]),
        clickContactUs(){
            window.open('https://www.vibrant-wellness.com/Contact','_blank');
        },
        clickNextStep(){
            this.goToNextStep(this.$router);
        }
    }
}
</script>

<style scoped>
.change-address-status-view{
    padding: 80px 316px 0px 316px;
}

.change-address-saved-view,
.change-address-failed-view{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.bold-content{
    margin-top: 77px;
    color: #0E4672;
    text-align: center;
    font-family: 'Roboto';
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
}
.change-address-failed-view .regular-content{
    margin-top:36px;
    color: #0E4672;
    text-align: center;
    font-family: 'Roboto';
    font-size: 18px;
    font-weight: 400;
    line-height: 21px;
}
.next-step-notice{
    margin-top: 36px;
    padding-top:26px;
    padding-bottom:26px;
    padding-left:117px;
    padding-right: 116px;
    border-radius: 4px;
    background: #20A8C3;

    text-align: center;
    color: #FFF;
    font-family: 'Roboto';
    font-size: 24px;
    font-weight: 400;
    line-height: 28px;
}
.clickable{
    cursor: pointer;
}
.regular-content .bold,
.next-step-notice .bold{
    font-weight: 700;
}
.change-address-saved-view .regular-content{
    margin-top: 36px;
    color: #0E4672;
    text-align: center;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
}
.link{
    color: #20A8C3;
    text-decoration: underline;
    cursor:pointer;
}
@media only screen and (max-width: 1260px) {
    .change-address-status-view{
        margin-top: 80px;
        padding:0 100px;
    }
    .next-step-notice{
        padding-left:58px;
        padding-right: 58px;
    }
}
@media only screen and (max-width: 767px) {
    .change-address-status-view{
        margin-top: 49px;
        padding-left:28px;
        padding-right:27px;
    }
    .change-address-failed-view img,
    .change-address-saved-view img{
        width: 120px;
        height: 120px;
    }

    .bold-content{
        margin-top: 36px;
        color: #0E4672;
        text-align: center;
        font-family: 'Roboto';
        font-size: 18px;
        font-weight: 700;
        line-height: 21px;
    }
    .next-step-notice{
        margin-top: 24px;
        padding-top: 12px;
        padding-bottom: 12px;
        padding-left: 13px;
        padding-right: 14px;
        border-radius: 4px;
        background: #20A8C3;
        color: #FFF;
        font-family: 'Roboto';
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
    }
    .change-address-failed-view .regular-content{
        margin-top: 24px;
        color: #0E4672;
        text-align: center;
        font-family: 'Roboto';
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }
    .change-address-saved-view .regular-content{
        margin-top: 24px;
        color: #0E4672;
        text-align: center;
        font-family: 'Roboto';
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }
}
</style>